import styled, { css } from '@xstyled/styled-components';

interface Props {
  variant?: 'default' | 'list' | 'center';
  image?: string | null;
}

/**
 * Utility component to layout its content while not capturing clicks
 */
export const Flex = styled.divBox<Props>`
  display: flex;
  box-sizing: border-box;
  pointer-events: none;
  > * {
    pointer-events: all;
  }
  ${p =>
    p.image
      ? css`
          background-size: cover;
          background-position: center;
          background-image: url(${p.image});
        `
      : ''}
  ${p => {
    switch (p.variant) {
      case 'list':
        return css`
          width: 100%;
          height: 100%;
          padding: ${p.theme.space.lg};
          flex-direction: column;
        `;
      case 'center':
        return css`
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
        `;
    }
  }}
`;
Flex.defaultProps = {
  variant: 'default'
};
